export default __webpack_public_path__ + "static/cesariaevora-7c4822e4de6461fff262e3677fa4d5c6.jpg";